<template>
<div class="row">
    <div class="col-12 text-center">
        <img src="@/assets/imgs/emptyEconomicGroup.svg" alt="">
        <h4 class="c-ndarkfour bold">
            {{ title }}
        </h4>
        <p class="c-ndarkfour">
            <slot></slot>
        </p>
    </div>
</div>
</template>

<script>
export default {
    props: {
        title: {
            required: true,
            type: String,
            default: 'Unknown'
        },
    }
}
</script>

<style lang="scss" scoped>
.row {
    padding-top: 56px;
}

img {
    margin-bottom: 40px;
}
</style>
